export default __webpack_public_path__ + "static/music1-47b5df978d5bc4b666983112ee81e7ae.pdf";